'use es6';

import { createSelector } from 'reselect';
import { getOriginalGenericChannelId } from 'conversations-thread-data/thread-details/public/operators';
import { getFocusedThreadDetails } from './getFocusedThreadDetails';
export const getFocusedThreadOriginalGenericChannelId = createSelector([getFocusedThreadDetails], threadDetails => {
  return getOriginalGenericChannelId(threadDetails) || null;
});